"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var bip32_path_1 = __importDefault(require("bip32-path"));
var CHUNK_SIZE = 150;
var CURVE_MASK = 0x80;
var CLA = 0xed;
var INS = {
    GET_VERSION: 0x02,
    GET_ADDRESS: 0x03,
    SET_ADDRESS: 0x05,
    PROVIDE_ESDT_INFO: 0x08
};
var SIGN_RAW_TX_INS = 0x04;
var SIGN_HASH_TX_INS = 0x07;
var SIGN_MESSAGE_INS = 0x06;
var ACTIVE_SIGNERS = [SIGN_RAW_TX_INS, SIGN_HASH_TX_INS, SIGN_MESSAGE_INS];
var SW_OK = 0x9000;
var SW_CANCEL = 0x6986;
var Elrond = /** @class */ (function () {
    function Elrond(transport, scrambleKey) {
        if (scrambleKey === void 0) { scrambleKey = "eGLD"; }
        this.transport = transport;
        transport.decorateAppAPIMethods(this, [
            "getAddress",
            "setAddress",
            "signTransaction",
            "signMessage",
            "getAppConfiguration",
            "provideESDTInfo",
        ], scrambleKey);
    }
    /**
     * Get Elrond app configuration.
     *
     * @return an object with a contractData, accountIndex, addressIndex, version
     * @example
     * const result = await elrond.getAppConfiguration();
     * const { contractData, accountIndex, addressIndex, version } = result;
     */
    Elrond.prototype.getAppConfiguration = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.transport.send(CLA, INS.GET_VERSION, 0x00, 0x00)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, {
                                contractData: response[0],
                                accountIndex: response[1],
                                addressIndex: response[2],
                                version: "".concat(response[3], ".").concat(response[4], ".").concat(response[5])
                            }];
                }
            });
        });
    };
    Elrond.prototype.serializePath = function (path) {
        var buf = Buffer.alloc(8);
        buf.writeUInt32BE(path[3], 0);
        buf.writeUInt32BE(path[2], 4);
        return buf;
    };
    /**
     * Get Elrond address for a given BIP 32 path.
     *
     * @param path a path in BIP 32 format
     * @param display optionally enable or not the display
     * @return an object with a address
     * @example
     * const result = await elrond.getAddress("44'/508'/0'/0'/0'");
     * const { address, returnCode } = result;
     */
    Elrond.prototype.getAddress = function (path, display) {
        return __awaiter(this, void 0, void 0, function () {
            var bipPath, data, response, addressLength, address;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        bipPath = bip32_path_1["default"].fromString(path).toPathArray();
                        data = this.serializePath(bipPath);
                        return [4 /*yield*/, this.transport.send(CLA, INS.GET_ADDRESS, display ? 0x01 : 0x00, 0x00, data, [SW_OK, SW_CANCEL])];
                    case 1:
                        response = _a.sent();
                        addressLength = response[0];
                        address = response.slice(1, 1 + addressLength).toString("ascii");
                        return [2 /*return*/, {
                                address: address
                            }];
                }
            });
        });
    };
    /**
     * Set Elrond address for a given BIP 32 path.
     *
     * @param path a path in BIP 32 format
     * @param display optionally enable or not the display
     * @return an object with a address
     * @example
     * const result = await elrond.setAddress("44'/508'/0'/0/0");
     * result : Buffer;
     */
    Elrond.prototype.setAddress = function (path, display) {
        return __awaiter(this, void 0, void 0, function () {
            var bipPath, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        bipPath = bip32_path_1["default"].fromString(path).toPathArray();
                        data = this.serializePath(bipPath);
                        return [4 /*yield*/, this.transport.send(CLA, INS.SET_ADDRESS, display ? 0x01 : 0x00, 0x00, data, [SW_OK, SW_CANCEL])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Elrond.prototype.signTransaction = function (path, message, usingHash) {
        return __awaiter(this, void 0, void 0, function () {
            var chunks, buffer, i, end;
            return __generator(this, function (_a) {
                chunks = [];
                buffer = Buffer.from(message);
                for (i = 0; i < buffer.length; i += CHUNK_SIZE) {
                    end = i + CHUNK_SIZE;
                    if (i > buffer.length) {
                        end = buffer.length;
                    }
                    chunks.push(buffer.slice(i, end));
                }
                return [2 /*return*/, usingHash
                        ? this.sign(chunks, SIGN_HASH_TX_INS)
                        : this.sign(chunks, SIGN_RAW_TX_INS)];
            });
        });
    };
    Elrond.prototype.signMessage = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.sign(message, SIGN_MESSAGE_INS)];
            });
        });
    };
    Elrond.prototype.sign = function (message, type) {
        return __awaiter(this, void 0, void 0, function () {
            var apdus, response, apdus_1, apdus_1_1, apdu, e_1_1, signature;
            var e_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!ACTIVE_SIGNERS.includes(type)) {
                            throw new Error("invalid sign instruction called: ".concat(type));
                        }
                        apdus = [];
                        message.forEach(function (data, index) {
                            var apdu = {
                                cla: CLA,
                                ins: type,
                                p1: index === 0 ? 0x00 : CURVE_MASK,
                                p2: CURVE_MASK,
                                data: data
                            };
                            apdus.push(apdu);
                        });
                        response = {};
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, 7, 8]);
                        apdus_1 = __values(apdus), apdus_1_1 = apdus_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!apdus_1_1.done) return [3 /*break*/, 5];
                        apdu = apdus_1_1.value;
                        return [4 /*yield*/, this.transport.send(apdu.cla, apdu.ins, apdu.p1, apdu.p2, apdu.data)];
                    case 3:
                        response = _b.sent();
                        _b.label = 4;
                    case 4:
                        apdus_1_1 = apdus_1.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _b.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (apdus_1_1 && !apdus_1_1.done && (_a = apdus_1["return"])) _a.call(apdus_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8:
                        if (response.length !== 67 || response[0] !== 64) {
                            throw new Error("invalid signature received from ledger device");
                        }
                        signature = response.slice(1, response.length - 2).toString("hex");
                        return [2 /*return*/, signature];
                }
            });
        });
    };
    Elrond.prototype.serializeESDTInfo = function (ticker, id, decimals, chainId, signature) {
        var tickerLengthBuffer = Buffer.from([ticker.length]);
        var tickerBuffer = Buffer.from(ticker);
        var idLengthBuffer = Buffer.from([id.length]);
        var idBuffer = Buffer.from(id);
        var decimalsBuffer = Buffer.from([decimals]);
        var chainIdLengthBuffer = Buffer.from([chainId.length]);
        var chainIdBuffer = Buffer.from(chainId);
        var signatureBuffer = Buffer.from(signature, "hex");
        var infoBuffer = [
            tickerLengthBuffer,
            tickerBuffer,
            idLengthBuffer,
            idBuffer,
            decimalsBuffer,
            chainIdLengthBuffer,
            chainIdBuffer,
            signatureBuffer,
        ];
        return Buffer.concat(infoBuffer);
    };
    Elrond.prototype.provideESDTInfo = function (ticker, id, decimals, chainId, signature) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!ticker || !id || !decimals || !chainId || !signature) {
                            throw new Error("Invalid ESDT token credentials!");
                        }
                        data = this.serializeESDTInfo(ticker, id, decimals, chainId, signature);
                        return [4 /*yield*/, this.transport.send(CLA, INS.PROVIDE_ESDT_INFO, 0x00, 0x00, data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return Elrond;
}());
exports["default"] = Elrond;
//# sourceMappingURL=index.js.map